module.exports = __webpack_public_path__ + "img/17.f4a5599a.jpg";